import { ChatButton } from "./components/chatbot";


function App() {
  return (
    <div className="App">
      <ChatButton/>
    </div>
  );
}

export default App;
